<template>
  <div>
    <div class="box">
      <div style="height: 50px;"></div>
      <div class="topBox" >
        <img src="../../../static/image/logo.png" class="logo"/>
        <div class="ptBox">
          <div @click="qydl()">企业登录</div>
          <div @click="yhindex()">线上商城</div>
          <div @click="sjyh()">手机用户</div>
        </div>
      </div>
      <div style="height: calc(50vh - 65px - 20vw);"></div>
      <div class="bodyBox" >
        <div class="bodyBox1" @click="gywm()">
          <img src="../../../static/image/6bx.png" />
          <div>关于我们</div>
        </div>
      </div>
      <div class="bodyBox" >
        <div class="bodyBox1" @click="zshz()">
          <img src="../../../static/image/6bx.png" />
          <div>招商合作</div>
        </div>
        <div class="bodyBox1" @click="qyjs()" style="height: 14vw;" >
          <img src="../../../static/image/6bx.png" style="width: 15.4vw;height: 14vw;"/>
          <div style="color: #FD8723;width: 7vw;height: 9vw;line-height: 4.5vw; font-size: 3.5vw;text-align: center;
            position: absolute;top: 2.2vw;left: 3vw;border-bottom: 0.4vw solid #FD8723;">企业介绍</div>
        </div>
        <div class="bodyBox1" @click="sjrz()">
          <img src="../../../static/image/6bx.png" />
          <div>商家入驻</div>
        </div>
      </div>
      <div class="bodyBox">
        <div class="bodyBox1" @click="ywms()">
          <img src="../../../static/image/6bx.png" />
          <div>业务模式</div>
        </div>
      </div>
    </div>
    <!-- <div class="footer">
    	<div style="padding-top: 20px;box-sizing: border-box;padding-left: 20px;">
    		<span>营业执照</span>
    		<span>加入我们</span>
    		<span>在线客服</span>
    	</div>
    	<p>版权所有：辽宁卡丁生活科技有限公司</p>
    	<p>辽ICP备20007334号</p>
    </div> -->
  </div>
</template>

<script>
  export default {
    data() {
      return {

      }
    },
    //初始化
    created(){

    },
    methods:{
      //关于我们
      gywm(){
        this.$router.push("/gywm")
      },
      //招商合作
      zshz(){
        this.$router.push("/zshz")
      },
      //企业介绍
      qyjs(){
        this.$router.push("/qyjs")
      },
      //商家入驻
      sjrz(){
        this.$router.push("/sjrz")
      },
      //业务模式
      ywms(){
        this.$router.push("/ywms")
      },
      //商城首页
      yhindex(){
        console.log("商城首页")
        this.$router.push("/index")
      },
      //企业登录
      qydl(){
        window.location.href="http://www.lnkading.com/home/login/login.html"
      },
      //
      sjyh(){
        console.log("弹窗小程序码")
      }
    }
  }
</script>

<style scoped>
  .box {
  	width: 100%;
  	height: calc(100vh - 0px);
  	box-sizing: border-box;
  	background: url("https://www.lnkading.com/uploads/temp/indexbg.png") no-repeat;
  	background-size:100% 100%;
  	position: relative;
  }
  .topBox{
    width:80%;
    margin: 0px auto;
    height: 80px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .logo{
    width: 5vw;
    height: 5vw;
  }
  .ptBox{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .ptBox>div{
    margin-left: 30px;
    font-size: 1.3vw;
    color: #fff;
    font-weight: 600;

  }
  .bodyBox{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .bodyBox1{
    width: 13vw;
    height: 11vw;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .bodyBox1>img{
    width: 11vw;
    height: 10vw;
  }
  .bodyBox1>div{
    width: 7vw;
    height: 7vw;
    font-size: 2.5vw;
    text-align: center;
    color: #FFFFFF;
    font-weight: 600;
    position: absolute;
    top: 2vw;
    left: 3vw;
  }



  .footer {
  	width: 100%;
  	height: 100px;
  	box-sizing: border-box;
  }
  .footer div span {
  	margin-left: 20px;
  	font-size: 14px;
  	line-height: 20px;
  	color: #999;
  }
  .footer p {
  	text-align: center;
  	font-size: 15px;
  	line-height: 20px;
  	color: #666;
  	margin-bottom:5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/official/home.vue